import { STATUS_LABEL, STATUS_STYLE, PRIORITY_LABEL, PRIORITY_STYLE } from "@/lib/constants";
import { cn } from "@/lib/utils";
import { useStatuses } from "@/context/StatusContext";

export function StatoBadge({ stato, className }) {
  const { labelOf, hexOf, statuses } = useStatuses();
  const known = STATUS_STYLE[stato];
  const custom = statuses.find((s) => s.key === stato && !STATUS_STYLE[s.key]);
  const style = custom ? { backgroundColor: `${hexOf(stato)}1a`, color: hexOf(stato), borderColor: `${hexOf(stato)}55` } : undefined;
  return (
    <span
      data-testid={`stato-badge-${stato}`}
      style={style}
      className={cn(
        "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold whitespace-nowrap",
        known || (custom ? "" : "bg-slate-100 text-slate-600 border-slate-200"),
        className
      )}
    >
      {labelOf(stato)}
    </span>
  );
}

export function PrioritaBadge({ priorita, className }) {
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold capitalize",
        PRIORITY_STYLE[priorita] || "bg-slate-100 text-slate-600 border-slate-200",
        className
      )}
    >
      {PRIORITY_LABEL[priorita] || priorita}
    </span>
  );
}
